import type { TFunction } from "i18next"

import type {
  ChatFilter,
  Conversation,
  ConversationKind
} from "../types/messaging.types.ts"

/** The secondary filter's options, in the order they read. */
export const CHAT_FILTERS: ChatFilter[] = [
  "all",
  "project_team",
  "contributor_group",
  "customer",
  "direct"
]

export const chatFilterLabel = (t: TFunction, filter: ChatFilter): string =>
  ({
    all: t("messages.filters.allChats", "All chats"),
    project_team: t("messages.filters.team", "Internal"),
    contributor_group: t("messages.filters.groups", "Groups"),
    customer: t("messages.filters.customer", "Customer"),
    direct: t("messages.filters.direct", "Private")
  })[filter]

export const kindLabel = (t: TFunction, kind: ConversationKind): string =>
  ({
    project_team: t("messages.kinds.projectTeam", "Project Team"),
    contributor_group: t("messages.kinds.group", "Selected participants"),
    direct: t("messages.kinds.direct", "Private"),
    customer: t("messages.kinds.customer", "Customer Chat")
  })[kind]

interface Filters {
  chatFilter: ChatFilter
  unreadOnly: boolean
}

/**
 * Narrowing a project's own rooms. The project is the page, so there is no
 * record axis here any more — only which kind of room, and whether it is
 * unread.
 */
export const applyFilters = (
  conversations: Conversation[],
  { chatFilter, unreadOnly }: Filters
): Conversation[] =>
  conversations.filter((row) => {
    if (chatFilter !== "all" && row.kind !== chatFilter) return false
    if (unreadOnly && row.unread_count === 0) return false
    return true
  })

/** Where the unread divider goes: before the first message the reader has not seen. */
export const firstUnreadIndex = (
  messageIds: string[],
  unreadCount: number
): number | null => {
  if (!unreadCount || unreadCount > messageIds.length) return null
  return messageIds.length - unreadCount
}
